let worker: Worker | null = null;
let seq = 0;

export function sha256File(file: File, onProgress?: (p: number) => void): Promise<string> {
  if (!worker) worker = new Worker(new URL("./hashWorker.ts", import.meta.url), { type: "module" });
  const w = worker;
  const id = ++seq;
  return new Promise((resolve, reject) => {
    const onMsg = (e: MessageEvent<{ id: number; hash?: string; error?: string; progress?: number }>) => {
      if (e.data.id !== id) return;
      if (e.data.progress !== undefined && onProgress) onProgress(e.data.progress);
      if (e.data.hash) {
        w.removeEventListener("message", onMsg);
        resolve(e.data.hash);
      } else if (e.data.error) {
        w.removeEventListener("message", onMsg);
        reject(new Error(e.data.error));
      }
    };
    w.addEventListener("message", onMsg);
    w.postMessage({ id, file });
  });
}
